var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { makeApiUrl } from '@/main/factories/http';
const API_BASE_URL = makeApiUrl('/');
class Api {
    translateSynthesize(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const config = {
                    method: 'post',
                    url: `${API_BASE_URL}aws-tp-widget/translate-synthesize`,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data
                };
                const response = yield axios.request(config);
                return response === null || response === void 0 ? void 0 : response.data;
            }
            catch (error) {
                console.error('Error fetching data:', error);
                return null;
            }
        });
    }
    translate(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const config = {
                    method: 'post',
                    url: `${API_BASE_URL}aws-tp-widget/translate`,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data
                };
                const response = yield axios.request(config);
                return response === null || response === void 0 ? void 0 : response.data;
            }
            catch (error) {
                console.error('Error fetching data:', error);
                return null;
            }
        });
    }
    getAwsPollyVoices() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const config = {
                    method: 'get',
                    url: `${API_BASE_URL}aws-tp-widget/aws-polly-voices`
                };
                const response = yield axios.request(config);
                return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.Voices;
            }
            catch (error) {
                console.error('Error fetching data:', error);
                return [];
            }
        });
    }
    getAwsTranslateLanguages() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const config = {
                    method: 'get',
                    url: `${API_BASE_URL}aws-tp-widget/aws-translate-languages`
                };
                const response = yield axios.request(config);
                return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.Languages;
            }
            catch (error) {
                console.error('Error fetching data:', error);
                return [];
            }
        });
    }
}
const api = new Api();
export default api;
